export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-11826c02',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
